<template>
  <div class="merchants-entering-box">
    <div class="merchants-entering">
      <img
        :src="logo"
        class="logo"
      >
      <div class="r-bg"></div>
      <Row :gutter="32">
        <Col :span="14">
        <div class="title">
          店铺信息
        </div>
        <Form
          :model="form"
          :label-width="80"
        >
          <FormItem label="店铺名称">
            <i-input
              v-model="merchantsName"
              placeholder="请输入您的店铺名称(必填)"
            ></i-input>
          </FormItem>
          <FormItem label="店铺地址">
            <Select
              style="width:140px"
              v-model="province"
              placeholder="请选择省份"
              @on-change="changeProvince"
            >
              <Option
                v-for="(item,index) in provinceArr"
                :key="index"
                :value="item.value"
              >{{ item.label }}</Option>
            </Select>
            <Select
              style="width:140px"
              v-model="city"
              placeholder="请选择城市"
              @on-change="changeCity"
            >
              <Option
                v-for="(item,index) in citiesArr"
                :key="index"
                :value="item.value"
              >{{ item.label }}</Option>
            </Select>
            <Select
              style="width:140px"
              v-model="county"
              placeholder="请选择区县"
            >
              <Option
                v-for="(item,index) in countyArr"
                :key="index"
                :value="item.value"
              >{{ item.label }}</Option>
            </Select>
            <!-- <i-input
              v-model="merchantsName"
              placeholder=""
            ></i-input> -->
          </FormItem>
          <FormItem label="">
            <Input
              v-model="address"
              type="textarea"
              :rows="4"
              placeholder="请输入您的详细地址"
            />
          </FormItem>
          <FormItem label="配送方法">
            <Select
              v-model="deliveryMethod"
              placeholder="请选择配送方法"
            >
              <Option
                v-for="(item,index) in deliveryMethodList"
                :key="index"
                :value="item"
              >{{ item }}</Option>
            </Select>
          </FormItem>
          <FormItem label="店铺规模">
            <Select
              v-model="storeSize"
              placeholder="请选择店铺规模"
            >
              <Option
                v-for="(item,index) in storeSizeList"
                :key="index"
                :value="item"
              >{{ item }}</Option>
            </Select>
          </FormItem>
        </Form>
        </Col>

        <Col
          :span="10"
          style="background: #FFFDF5;"
        >
        <div class="title">
          联系方式
        </div>
        <Form
          :model="form"
          :label-width="80"
        >
          <FormItem label="您的姓名">
            <i-input
              v-model="name"
              placeholder=""
            ></i-input>
          </FormItem>
          <FormItem label="手机号">
            <i-input
              v-model="phone"
              placeholder=""
            ></i-input>
          </FormItem>
          <FormItem label="邮箱号">
            <i-input
              v-model="email"
              placeholder=""
            ></i-input>
          </FormItem>
          <FormItem label="微信号">
            <i-input
              v-model="weChatNumber"
              placeholder=""
            ></i-input>
          </FormItem>
          <FormItem label="">
            <i-button
              long
              size="large"
              type="warning"
              @click="submit()"
            >确认</i-button>
          </FormItem>
          <FormItem label="">
            <Checkbox v-model="isAgree">我同意</Checkbox>
            <p class="aggree-msg">已确保输入信息正确属实，并同意<span @click="openAgreementBox()">《商户入驻协议》</span></p>
          </FormItem>
        </Form>
        </Col>
      </Row>

    </div>
    <agreement
      ref="agreement"
      @sure="sure"
    ></agreement>
  </div>
</template>
<script>
import { logo } from '../../images/merchants-entering/index'
import data from '../data/address'
import agreement from './agreement'
import axios from 'axios'
import httpRequestUrl from '../../../js/send'
console.log(data)
export default {
  data () {
    return {
      merchantsName: null,
      logo,
      form: {},
      provinceArr: [],
      province: null,
      citiesArr: [],
      city: null,
      countyArr: [],
      county: null,
      address: null,
      isAgree: false,
      name: null,
      phone: null,
      email: null,
      weChatNumber: null,
      deliveryMethod: null,
      deliveryMethodList: [
        '自配送',
        '美团配送'
      ],
      storeSize: null,
      storeSizeList: [
        '连锁',
        '非连锁'
      ]
    }
  },
  components: {
    agreement
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.provinceArr = data.data
      console.log(data)
    },
    changeProvince (val) {
      for (var i = 0; i < this.provinceArr.length; i++) {
        if (val == this.provinceArr[i].value) {
          this.citiesArr = this.provinceArr[i].children
          this.county = ''
          this.countyArr = []
        }
      }
    },
    changeCity (val) {
      for (var i = 0; i < this.citiesArr.length; i++) {
        if (val == this.citiesArr[i].value) {
          this.countyArr = this.citiesArr[i].children
        }
      }
    },
    sure () {
      this.isAgree = true
    },
    submit () {
      if (!this.merchantsName) {
        this.$Message.warning('请输入店铺名称后提交')
        return false
      }
      if (!this.province || !this.city || !this.county || !this.address) {
        this.$Message.warning('请输入店铺地址后提交')
        return false
      }
      if (!this.deliveryMethod) {
        this.$Message.warning('请输入配送方法后提交')
        return false
      }
      if (!this.storeSize) {
        this.$Message.warning('请输入店铺规模后提交')
        return false
      }
      if (!this.name) {
        this.$Message.warning('请输入您的姓名后提交')
        return false
      }
      if (!this.phone && !this.email && !this.weChatNumber) {
        this.$Message.warning('请至少填写一个联系方式后提交')
        return false
      }
      if (!this.isAgree) {
        this.$Message.warning('请阅读商户入驻协议后提交')
        this.openAgreementBox()
        return false
      }
      this.send()
    },
    openAgreementBox () {
      // alert(123456)
      this.$refs.agreement.init()
    },
    send () {
      // console.log(this.$httpRequestUrl)
      axios.post(httpRequestUrl + '/merchant/send', {
        merchantsName: this.merchantsName,
        province: this.province,
        city: this.city,
        county: this.county,
        address: this.address,
        deliveryMethod: this.deliveryMethod,
        storeSize: this.storeSize,
        name: this.name,
        phone: this.phone,
        email: this.email,
        weChatNumber: this.weChatNumber
      })
        .then(function (response) {
          console.log(response);
          if (response.code === 0) {
            this.$Message.success('发送成功')
            this.$router.push('/')
          } else {
            this.$Message.error(response.msg)
          }
        })
        .catch(function (error) {

        });
    }
  }
}
</script>
<style scoped>
* {
  font-family: 'Courier New', Courier, monospace !important;
}
.merchants-entering-box {
  width: 100%;
  height: 100%;
  overflow: auto;
  box-sizing: border-box;
  padding-top: 150px;
}
.merchants-entering {
  width: 1000px;
  height: 550px;
  box-shadow: 0px 3px 62px 0px rgba(0, 0, 0, 0.11);
  padding: 20px;
  margin: 0 auto;
  overflow: auto;
  position: relative;
  /* margin: 0 auto; */
  /* border: solid 1px red; */
}
.logo {
  display: block;
  width: 350px;
  margin-bottom: 20px;
}
.merchants-entering >>> .ivu-form-item-label,
.merchants-entering >>> .ivu-select-selected-value,
.merchants-entering >>> .ivu-select-placeholder {
  font-family: 'Courier New', Courier, monospace !important;
  font-weight: bold;
}
.title {
  font-size: 20px;
  font-weight: bold;
  text-indent: 10px;
  margin-bottom: 20px;
}
.r-bg {
  position: absolute;
  width: 415px;
  height: 100%;
  right: 0;
  top: 0;
  background: #fffdf5;
  z-index: 0;
}
.aggree-msg {
  font-size: 12px;
  text-align: right;
}
* >>> .ivu-checkbox-wrapper {
  font-size: 12px;
  text-align: right;
  display: block;
}
.aggree-msg span {
  text-decoration: underline;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/merchants-entering/pc/index.vue